import { render } from "./RegisterQuestionSelection.html?vue&type=template&id=1d3604cc&external"
import script from "./RegisterQuestionSelection.js?vue&type=script&lang=js&external"
export * from "./RegisterQuestionSelection.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__